import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconDelivery$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDelivery extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '3ae2b3dc9b7595bb71a177a2b0d68041a195dbe4', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '9c2bfd1b52cb1af0fd637b9db26f4d9623cbd674', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '2fd84df849db8d6e06f855d8027b2a949a164c6b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13 9.5v-3h3.08l1.89 3zm0 4V11h5.5v2.5zm2.53 4.5a1.5 1.5 0 1 1-.06-2.999A1.5 1.5 0 0 1 15.53 18m-12-4.5v-9h8v9zm3 4.5a1.5 1.5 0 1 1 1.024-.432A1.5 1.5 0 0 1 6.48 18zm0 1.5a3 3 0 0 0 3-3A2.75 2.75 0 0 0 9 15h4a2.8 2.8 0 0 0-.44 1.52 3 3 0 1 0 6 0 2.7 2.7 0 0 0-.48-1.52h1.42a.5.5 0 0 0 .5-.5v-4.33a.6.6 0 0 0-.08-.38l-2.87-4.55a.5.5 0 0 0-.42-.24H13V3.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h1.43a2.7 2.7 0 0 0-.45 1.5 3 3 0 0 0 3.01 3z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-delivery", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-delivery"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-delivery":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDelivery$1);
            }
            break;
    } });
}

const CosmosIconDelivery = CosmosIconDelivery$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDelivery, defineCustomElement };
